import { type FC, memo, useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import { type BuyCoinItemProps } from '@/common/types/components';
import { type TgemPurchaseSource } from '@/common/types/modal';
import { ModalContext } from '@/components/Modals/Modal/config';
import { H3 } from '@/components/Typography/Typography';
import { MainButton } from '@/components/ui/Button/Button';

import { OfferItem } from '../OfferItem/OfferItem';

interface OffersListProps {
  list: BuyCoinItemProps[];
  isModal?: boolean;
  source: TgemPurchaseSource;
}

const OffersList: FC<OffersListProps> = memo(({ list, isModal, source }) => {
  const popularOffer = list.find((_, index) => index === 3);
  const initialOffer = popularOffer ?? list[0];
  const [activeOffer, setActiveOffer] = useState<BuyCoinItemProps | undefined>(
    initialOffer,
  );
  const { t } = useTranslation();
  const { openModal, secondModal, isOpen } = useContext(ModalContext);

  if (!activeOffer) {
    return null;
  }

  const openBuyModal = (): void => {
    if (isOpen) {
      secondModal.openModal({
        renderKind: 'buySingleTgems',
        props: { activeOffer, source },
      });
    } else {
      openModal({
        renderKind: 'buySingleTgems',
        props: { activeOffer, source },
      });
    }
  };

  // const top = tabBarPosition
  //   ? tabBarPosition.top - tabBarPosition.height - convertRemToPixels(4)
  //   : convertRemToPixels(4) * -1;

  return (
    <>
      <div
        className={cn(
          'w-full relative flex flex-col',
          isModal && 'gap-2.5 pb-20',
          !isModal && 'gap-2 pb-2 grow',
        )}
      >
        {list.map((el, index) => {
          const { price, coin, withDiscount, itemDiscount } = el;
          const vipObj: Record<number, number> = {
            6500: 30,
            2500: 14,
            575: 3,
            220: 1,
          };

          return (
            <OfferItem
              item={el}
              isFirstPurchase={withDiscount}
              key={index}
              price={price}
              tgem={coin}
              baseTgem={withDiscount ? coin / 2 : undefined}
              bonus={!withDiscount && itemDiscount ? itemDiscount : undefined}
              id={coin}
              vip={withDiscount ? undefined : vipObj[coin]}
              isActive={coin === activeOffer.coin}
              changeActiveOffer={setActiveOffer}
              isPopular={index === 3}
            />
          );
        })}
      </div>
      <div
        className={cn({
          'w-full h-20 mt-auto p-2 pt-4 bg-main-bg z-[5]': !isModal,
          'w-full px-2': isModal,
        })}
      >
        <MainButton text="" onClick={openBuyModal}>
          <H3 weight="extrabold" className="white-text-shadow-gradient">
            {t('Buy for')} ${activeOffer.price}
          </H3>
        </MainButton>
      </div>
    </>
  );
});

export { OffersList };
